import { Component, OnInit ,ViewChild , Input, Output, EventEmitter} from '@angular/core';
import { CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';
import * as moment from 'moment';
@Component({
  selector: 'app-unavailablecalender',
  templateUrl: './unavailablecalender.component.html',
  styleUrls: ['./unavailablecalender.component.scss']
})
export class UnavailablecalenderComponent implements OnInit {
  calendarOptions: Options;
  @Output() onDatePicked: EventEmitter<any> = new EventEmitter<any>();
  events:any = [];
  customSelectedEvents:any = [];
  defaultSecondDate:string;
  blockDates:any;
  blockObj:any={};
@ViewChild(CalendarComponent) ucCalendarStart: CalendarComponent;
 
  constructor() {
    this.calendarOptions = {
      editable: true,
      eventLimit: false,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay,listMonth'
      },
      selectable: true,
      events: [],
      };
  }
  initMethods(){
    let second = moment().add('months', 1);
    this.defaultSecondDate = this.formatDate(second.toDate())
  }
  formatDate(date:Date){
    //let formatted = this.datepipe.transform(date, 'yyyy-MM-dd');
    var local = moment(date).local().format('YYYY-MM-DD');
    console.log("date : ", date)
    console.log("formatted : ", local)
  
    return local;

  }
  makeEvent(date){
    let obj = {
      title: '',
      start: date,
      allDay: true,
      backgroundColor: '#000000',
      eventColor: '#dd1919',
      overlap: false,
      rendering: 'background'  
    }
    return obj;
}

  ngOnInit() {
  }
  updateUnavailableDates(dates:any){
    this.blockDates=dates;
    console.log("customSelectedEvents123",this.customSelectedEvents);
    while (this.events.length > 0) {
      this.events.pop();
    }

    for(var k in this.customSelectedEvents){
      this.events.push(this.customSelectedEvents[k]) 
    }

    for(var i in dates){

      this.events.push(this.makeEvent(dates[i])) 
    }

    this.ucCalendarStart.renderEvents(this.events)
  
  }
  eventDrop(model:any){
    console.log("model123",model);
    return;
  }
  dragScroll(model:any){
    console.log("model123model ",model);
  }
  dayClick(model:any){
    this.blockObj
    console.log("model123",this.events);
    let date = this.formatDate(model.date);
    let blockDate=date+'T00:00:00.000Z';
    var existing =  this.events.find(x => x.start == blockDate);
    if(!existing){  
      let eventTemp = this.makeEvent(blockDate)
      this.customSelectedEvents.push(eventTemp) 
      this.events.push(eventTemp)
      this.blockObj.add=date;
    }else{
      const index = this.events.indexOf(existing, 0);
      if (index > -1) {
        this.events.splice(index, 1);
      }
      var existing2 =  this.customSelectedEvents.find(x => x.start == date);
      const indexTemp = this.customSelectedEvents.indexOf(existing2, 0);
      if (indexTemp > -1) {
          this.customSelectedEvents.splice(indexTemp, 1);
      }
      this.blockObj.remove=date;
    }
    this.ucCalendarStart.renderEvents(this.events);
    this.onDatePicked.emit(this.blockObj);
  }
}
